<template>
    <div class="uk-padding">
        <img width="15%" src="https://trainingvideocompliance.s3.amazonaws.com/KIR+Logo+w+AAA+on+Hat.JPG">
        <div class="uk-margin-top">
            <slot class="uk-text-left"></slot>
            <h2 class="uk-text-left"><strong>Question {{multiple_choice.question_number+1}}: </strong></h2>
            <p class="uk-text-large uk-text-bold" style="font-size:1.6em">{{ multiple_choice.question }}</p>
            <div class="uk-margin-top">
            <!-- <div v-for="(item, index) in answers">
                    <div v-if="multiple_choice.answer_one.length > 0"
                        class="uk-border-rounded border uk-padding-small uk-text-center uk-margin-top"
                        :class="{selected:selected_el == '1'}"  
                        @click="selectAnswer('1')">
                        <div class="uk-position-relative uk-flex-middle uk-flex">
                            <p style="position:absolute; text-align: left; margin: 0">A)</p>
                            <p style="margin:0;" :style="textscale" class="uk-text-large">{{ multiple_choice.answer_one }}</p>
                        </div>
                    </div>
                 </div> -->

                <div v-if="multiple_choice.answer_one.length > 0"
                    class="uk-border-rounded border uk-padding-small uk-margin-top"
                    :class="{selected:selected_el == '1'}"  
                    @click="selectAnswer('1')">
                    <div class="uk-position-relative uk-flex-middle uk-flex">
                        <p style="position:absolute; text-align: left; margin: 0">A)</p>
                        <p style="margin:0;" :style="textscale" class="uk-text-large">{{ multiple_choice.answer_one }}</p>
                    </div>
                </div>

                <div v-if="multiple_choice.answer_two.length > 0"
                    class="uk-border-rounded border uk-padding-small uk-margin-top"
                    :class="{selected:selected_el == '2','uk-margin-top':checkmargin}" 
                    @click="selectAnswer('2')">
                    <div class="uk-position-relative uk-flex-middle uk-flex">
                        <p style="position:absolute; text-align: left; margin: 0">B)</p>
                        <p style="margin:0;" :style="textscale" class="uk-text-large">{{ multiple_choice.answer_two }}</p>
                    </div>
                </div>

                <div v-if="multiple_choice.answer_three.length > 0"
                    class="uk-border-rounded border uk-padding-small uk-margin-top"
                    :class="{selected:selected_el == '3'}" 
                    @click="selectAnswer('3')">
                    <div class="uk-position-relative uk-flex-middle uk-flex">
                        <p style="position:absolute; text-align: left; margin: 0">C)</p>
                        <p style="margin:0;" :style="textscale" class="uk-text-large">{{ multiple_choice.answer_three }}</p>
                    </div>
                </div>
                
                <div v-if="multiple_choice.answer_four.length > 0"
                    class="uk-border-rounded border uk-padding-small uk-margin-top"
                    :class="{selected:selected_el == '4','uk-margin-top':checkmargin}" 
                    @click="selectAnswer('4')">
                    <div class="uk-position-relative uk-flex-middle uk-flex">
                        <p style="position:absolute; text-align: left; margin: 0">D)</p>
                        <p style="margin:0;" :style="textscale" class="uk-text-large">{{ multiple_choice.answer_four }}</p>
                    </div>
                </div>

                <div v-if="multiple_choice.answer_five.length > 0"
                    class="uk-border-rounded border uk-padding-small uk-margin-top"
                    :class="{selected:selected_el == '5','uk-margin-top':checkmargin}" 
                    @click="selectAnswer('5')">
                    <div class="uk-position-relative uk-flex-middle uk-flex">
                        <p style="position:absolute; text-align: left; margin: 0">E)</p>
                        <p style="margin:0;" :style="textscale" class="uk-text-large">{{ multiple_choice.answer_five }}</p>
                    </div>
                </div>

            </div>
            <hr>
            <div :style="buttonText" class="uk-text-center uk-flex uk-flex-center btn-extra-large-text">
                <button class="uk-button uk-button-primary uk-margin-right navigate-frame-btn" 
                        @click="previousFrameQuestion"><span uk-icon="icon: chevron-left; ratio: 2"></span>Previous</button>
                <button v-if="answerselected" 
                        class="uk-button uk-button-primary uk-margin-left navigate-frame-btn" 
                        @click="nextFrameQuestion">Next<span uk-icon="icon: chevron-right; ratio: 2"></span></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "app-question",
    props: {
            multiple_choice: {
                type: Object
            },
            question_number: {
                type: Number,
                default: 0
            },
            frameNum:{
                type: Number,
                default: 0
            },
            nextFrame:{
                type: Function
            },
            previousFrame: {
                type: Function
            },
            updateAnswer:{
                type: Function
            }
    },
    data () {
        return {
            answer: "none",
            selected_el: "",
            answerselected: false,
            width: window.innerWidth,
            multiple_choice_keys: ["answer_one", "answer_two", "answer_three", "answer_four", "answer_five"],
            answers: [],
            
        }
    },
    computed: {
        textscale(){
            if(window.innerWidth < 801){
                return `font-size: 3.5vw;padding-left:5vw`
            } else {
                return `font-size: 1.5vw;padding-left:3vw`
            }
        },
        sizing(){
            if(window.innerWidth < 801){
                return `uk-column-1 uk-margin-top`
            } else {
                return `uk-column-1-2 uk-margin-top`
            }
        },
        checkmargin(){
            return window.innerWidth < 801 ? `uk-margin-top`: ""
        },
        buttonText(){
            return window.innerWidth < 801 ? `font-size: .9em`: ``
        }
    },
    methods: {
        selectAnswer(newanswer){
            this.selected_el = newanswer
            // this.$emit('updateAnswer', {questionNumber:this.questionNumber, answer:newanswer})
            this.updateAnswer(this.multiple_choice.question_number, newanswer)
            this.answerselected = true
        },
        previousFrameQuestion(){
            this.previousFrame(this.frameNum-1)
        },
        nextFrameQuestion(){
            this.nextFrame(this.frameNum+1)
        },
        finishTest(){
            this.$emit('sendAnswers')
        }
    }
}
</script>

<style lang="less" scoped>
    .border {
        border: 1px solid #375A8B;
        cursor: pointer;
    }
    .border:hover {
        color: #ffffff;
        background-color: #375A8B;
    }

    .selected {
        color: #ffffff;
        background-color: #375A8B;
    }

    .padding-top-none {
        padding-top: 0;
    }
</style>
